import { Injectable, ComponentFactory, ComponentFactoryResolver } from '@angular/core';
import { UserActionService, IUserActionResponder } from '@core_n/user-action/user-action.service';
import { AspObject } from '@core_n/asp/AspObject';
import * as projConsts from '../common/projConsts';
import { SetDoubleFlagActionComponent } from './set-double-flag-action.component';

//
// Paamon project user actions service.
// Use it for all Paamon specific actions.
//

@Injectable({
  providedIn: 'root'
})
export class UserActionsService {

  constructor(private userActionService: UserActionService,
              private compFactResolver: ComponentFactoryResolver) { }

  activateAction(action: number, obj: AspObject, responder: IUserActionResponder) {
    let prompt: string;
    let cursor: string;
    let bodyFactory: ComponentFactory<any>;
    let okButtonShown;

    if (action == projConsts.USER_ACTION_MERGE_TRACKS) {
      prompt = 'Select track to merge';
      cursor = 'pointer';
    }
    else if (action == projConsts.USER_ACTION_SET_DOUBLE_FLAG) {
      bodyFactory = this.compFactResolver.resolveComponentFactory(SetDoubleFlagActionComponent);
      okButtonShown = true;
    }
    
    this.userActionService.activateAction(action, prompt, obj, responder, bodyFactory, okButtonShown, cursor);
  }
}
